import { render, staticRenderFns } from "./vfg-vsnumber.vue?vue&type=template&id=fb1493ce"
import script from "./vfg-vsnumber.vue?vue&type=script&lang=js"
export * from "./vfg-vsnumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports